import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blocks/stay-updated/stay-updated.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/navbar/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/section-layout/section-layout.module.scss");
